import { useEffect } from 'react';
import useStripeAccount from '@hooks/useStripeAccount';
import useUser from './useUser';

// Ensures that the user has a stripe account setup & we are watching it for changes
export function useStripeAccountRequired() {
    const { watchingStripeAccount, stripeAccountRequired } = useStripeAccount();
    const { refresh } = useUser();

    useEffect(() => {
        // refresh user once on load, in case the stripe account just go setup on page load
        // the user info watcher isn't being triggered when stripe info is added to the stripe account
        refresh();
        if (!watchingStripeAccount) {
            stripeAccountRequired();
        }
    }, [watchingStripeAccount, stripeAccountRequired, refresh]);
}
